@if (uiMap.isShowAvatar) {
  <div class="fn-avtar-text" [class]="textClass" [style]="{'background-color': uiMap.bgColor}" >
    <span>{{ uiMap.initialWords }}</span>
  </div>
} @else {
  <img [(src)]="imgUrl" class="fn-avtar-text-img"  [class]="imgClass">
}
